import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SnackMessageData } from '../../app/model/snack-message-data';
import { RootState } from '../../app/store';

interface MessagingState extends SnackMessageData {
    open: boolean;
}

const initialState: MessagingState = {
    open: false,
    type: 'error',
    message: '',
};

const messagingSlice = createSlice({
    name: 'messaging',
    initialState,
    reducers: {
        showMessage: (state, action: PayloadAction<SnackMessageData>) => {
            state.open = true;
            state.type = action.payload.type;
            state.message = action.payload.message;
        },
        hideMessage: (state) => {
            state.open = false;
        },
    },
});

// main reducer
export const MessagingReducer = messagingSlice.reducer;

// selectors
export const selectActiveMessage = (state: RootState): SnackMessageData | undefined => {
    if (!state.messaging.open) {
        return undefined;
    }

    return { type: state.messaging.type, message: state.messaging.message };
};

// action
export const { showMessage, hideMessage } = messagingSlice.actions;
